import { Route, Navigate, Routes, useLocation } from "react-router";
import { DailyEntryPage } from "./DailyEntryPage/DailyEntryPage";
import 'primeflex/primeflex.css';
import './Journal.css';
import React, { useEffect, useRef } from "react";
import { LoadingBlock } from "./SharedComponents";
import { HomePage } from "./HomePage/HomePage";
import { JournalViewModel } from "../../ViewModel/JournalViewModel";
import { RecapPage } from "./RecapPage/RecapPage";
import { SettingsPage } from "./SettingsPage/SettingsPage";
import { RecapEntryPage } from "./RecapEntryPages/RecapEntryPage";
import { NavBar } from "./SharedComponents/NavBar";
import { AppHeader } from "./SharedComponents/AppHeader";
import { Tutorial } from "./SharedComponents/Tutorial";
import { FeedbackEntryPage } from "./Feedback/Feedback";
import { appInsights } from "../../Services/AppInsightsService";
import { TrendsPage } from "./TrendsPage/TrendsPage";
import { PropertyChangedUtility } from "../../Utilities/NotifyPropertyChangedBase";

export const JournalRouteFragment = "journal";

export interface IHeaderSetters {
    clear: () => void;
    setHeaderTitle: (title: string) => void;
    setSubtitle: (subtitle: string) => void;
    setHeaderDate: (date: string) => void;
    setIsReadyToRender: (isReady: boolean) => void;
}

function JournalRoutes({ viewModel, headerSetters }: { viewModel: JournalViewModel, headerSetters: IHeaderSetters }) {
    // const { pathname } = useLocation();
    const count = useRef(0);

    count.current++;

    // console.log(`Render|Journal(${count.current}):  ${pathname}`);


    return (
        <Routes>
            <Route path="daily/*" element={<DailyEntryPage headerSetters={headerSetters} />} />
            <Route path="recap/*" element={<RecapPage headerSetters={headerSetters} />} />
            <Route path="recapEntry/*" element={<RecapEntryPage journalViewModel={viewModel} headerSetters={headerSetters} />} />
            <Route path="home/*" element={<HomePage journalViewModel={viewModel} headerSetters={headerSetters} />} />
            <Route path="settings/*" element={<SettingsPage journalViewModel={viewModel} headerSetters={headerSetters} />} />
            <Route path="feedback/*" element={<FeedbackEntryPage />} />
            <Route path="trends/*" element={<TrendsPage journalViewModel={viewModel} headerSetters={headerSetters} />} />
            <Route path="*" element={<Navigate to={`${DefaultJournalRoute}`} />} />
        </Routes >
    );
}


const DefaultJournalRoute = "home";
export function Journal() {


    const [headerSetters, setHeaderSetters] = React.useState<IHeaderSetters>({
        clear: () => undefined,
        setHeaderTitle: () => undefined,
        setSubtitle: () => undefined,
        setHeaderDate: () => undefined,
        setIsReadyToRender: () => undefined
    });

    const { pathname } = useLocation();

    const isFeedbackRoute = pathname.indexOf('feedback') >= 0;




    const [viewModel, setViewModel] = React.useState<JournalViewModel | undefined>(undefined);
    const [showLoading, setShowLoading] = React.useState<boolean>(true);

    useEffect(() => {

        JournalViewModel.GetModel().then((vm) => {
            setViewModel(vm);
            setShowLoading(vm.isHydrated === false);

            const onPropertyChanged = PropertyChangedUtility.onPropertyChanged(
                'isHydrated',
                (arg) => setShowLoading(arg.source.isHydrated === false)
            );

            vm.PropertyChanged.Subscribe(onPropertyChanged);

            return () => {
                vm.PropertyChanged.Unsubscribe(onPropertyChanged);
            }

        });
    }, []);

    if (showLoading) { // TODO: Add a isReadyToRender to the JournalViewModel
        const reason = viewModel === undefined ? 'viewModel undefined' : 'viewModel not hydrated';
        appInsights.trackTrace({ message: 'JournalViewModelNotReady', properties: { reason: reason, pathname: pathname } });
        return <LoadingBlock showLogo />
    }


    return (
        <div className="gl-journal flex flex-column h-full v-full">
            {
                !isFeedbackRoute &&
                <AppHeader
                    updateHeader={(setters) => setHeaderSetters(setters)}
                />
            }
            <div className="gl-page-container flex-grow-1 v-full" >
                <JournalRoutes viewModel={viewModel!} headerSetters={headerSetters} />
            </div>

            {!isFeedbackRoute && <NavBar journalViewModel={viewModel!} />}
            <Tutorial journalViewModel={viewModel!} />
        </div>
    );
}